module.exports = __webpack_public_path__ + "static/img/IMG_20161120_124102.81b95142.jpg";